module.exports = __webpack_public_path__ + "static/media/visa.17821423.svg";